// utils/tokenEvents.js
export const tokenEvents = new EventTarget();

// Dispatch token changed event (in-tab)
export const notifyTokenChange = () => {
  tokenEvents.dispatchEvent(new Event("tokenChanged"));
};
